// actions/types.js

// =========================
// Action Types for Redux
// =========================

/**
 * Set the current sutra (master) index.
 * Used to track user's current position in the sutra progression.
 */
export const SET_MASTER = "SET_MASTER";

/**
 * Set the current points for the sutra.
 * Used to track user's score or progress within a sutra.
 */
export const SET_POINTS = "SET_POINTS";

/**
 * Set the current question number.
 * Used to track which question the user is currently on within a sutra.
 */
export const SET_QUESTION = "SET_QUESTION";

/**
 * Toggle the sound setting in the app.
 * Used to enable or disable sound effects globally.
 */
export const TOGGLE_SOUND = "TOGGLE_SOUND";
